import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isCurrentSegment',
  standalone: true,
})
export class CurrentSegment implements PipeTransform {
  public transform = (segments: string[], activeSegment: string): boolean =>
    segments.some((segment) => segment === activeSegment.toLowerCase());
}
